module.exports = __webpack_public_path__ + "static/img/door-gc1.df7a856.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/door-gc/door-gc1.jpg
// module id = Eo9A
// module chunks = 0